<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('fines.title') }}</h1>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('fines_add')"
              color="warning mt-2"
              large
              depressed
              @click="dialog = true"
            >
              {{ $t('fines.add') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <fines-table
      class="mt-5"
      :updated="updated"
      @update-error="
        snack = {
          value: true,
          color: 'error',
          message: $t('common.errors.APIerror'),
        }
      "
      @updated="
        snack = {
          value: true,
          color: 'success',
          message: $t('common.saved'),
        }
      "
    />

    <fines-dialog v-model="dialog" @saved="onUpdate" />

    <v-snackbar v-model="snack.value" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import FinesTable from '@/components/fines/FinesTable.vue';
import FinesDialog from '@/components/fines/FinesDialog.vue';

export default {
  components: { FinesTable, FinesDialog },
  data: () => ({
    dialog: false,
    updated: false,
    snack: {
      value: false,
      color: '',
      message: '',
    },
  }),
  methods: {
    onUpdate({ success }) {
      if (!success) {
        this.snack = {
          value: true,
          color: 'error',
          message: this.$t('common.errors.APIerror'),
        };

        return;
      }

      this.dialog = false;
      this.updated = true;
    },
  },
};
</script>

<style></style>
